import React, { useEffect } from "react"
export interface SocialFeedProps {
    feed_key: string
    id: string
}

export const SocialFeedCmp: React.FC<SocialFeedProps> = ({
    feed_key,
    id,
}) => {
    useEffect(() => {
        var i,e,d=document,s="script";i=d.createElement("script");i.async=1;i.charset="UTF-8";
        i.src="https://cdn.curator.io/published/" + feed_key  + ".js";
        e=d.getElementsByTagName(s)[0];e.parentNode.insertBefore(i, e);
    }, [])

    return (
        <>
        <div id={id}>
            <a href="https://curator.io" target="_blank" className="crt-logo crt-tag"></a>
        </div>
        </>
    )
}